export default __webpack_public_path__ + "static/media/about-vision.52c6cb45.jpg";